import { TAGS } from '../../../../../shared/constants/analyticsConstants/generativeCallReview';

export const isNonContainedContainableCall = (call: { isContainable: boolean; isContained: boolean; tags: string[] }): boolean =>
    call.isContainable === true && call.isContained !== true && !call.tags.includes(TAGS.OUTBOUND_CALL);
